import { useEffect } from 'react';
import { useTheme } from './useTheme';

// Arbres des attendus déjà chargés, par niveau, le temps de la page : le
// référentiel est le même pour tous les profs et ne change pas en cours de
// séance. Repasser sur un niveau, ou rouvrir le menu, est alors instantané.
const ARBRES = new Map();

/**
 * L'arbre des attendus d'un niveau pour le menu d'attendu (autre niveau que
 * la classe, 2026-09-29) : chargé seulement si `actif`, puis gardé en mémoire.
 * `isLoading` reste vrai tant que le premier chargement n'a rien rendu, pour
 * que le menu montre ses lignes d'attente au lieu d'une liste vide.
 */
export const useThemeEnCache = (niveau, actif) => {
    const enCache = ARBRES.get(niveau);
    const { data, isLoading } = useTheme(niveau, actif && !enCache ? undefined : 'not-enabled');
    const recu = Array.isArray(data) && data.length > 0;

    useEffect(() => {
        if (actif && !enCache && !isLoading && recu) ARBRES.set(niveau, data);
    }, [actif, enCache, isLoading, recu, niveau, data]);

    if (enCache) return { data: enCache, isLoading: false };
    return { data: recu ? data : [], isLoading: Boolean(actif) && (isLoading || !recu) };
};
